// Texts of the login screen, face login and the KVKK (data protection) consent.
const login = {
  title: 'Welcome',
  subtitle: 'Sign in to the HabcareCRO portal',
  email: 'E-mail',
  emailPlaceholder: 'name@habcarecro.com',
  password: 'Password',
  passwordPlaceholder: 'Your password',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  capsLock: 'Caps Lock is on',
  submit: 'Sign In',
  submitting: 'Signing in...',
  or: 'or',
  face: 'Sign in with face recognition',
  faceBusy: 'Your device is verifying…',
  faceHint: 'Windows Hello, Face ID or fingerprint',
  forgot: 'Forgot password',
  language: 'Language',
  copyright: '© HabcareCRO. All rights reserved.',
  errors: {
    invalid: 'Invalid e-mail or password',
    inactive: 'Your access has been revoked.',
    incomplete: 'Sign-in could not be completed',
    generic: 'Something went wrong while signing in',
    kvkkSave: 'Your consent could not be saved. Please try again.',
    kvkkRejected: 'You cannot sign in without accepting the KVKK notice.',
  },
  setup: {
    title: 'Set up face recognition',
    body: "Face recognition isn't set up on this device yet. Sign in once with your e-mail and password; then we'll register your face.",
    cancel: 'Cancel',
    tryAnyway: "It's already set up on this device, try anyway",
  },
  passkey: {
    cancelled: 'Face verification was not completed.',
    unknown: "This device's face sign-in is no longer valid. Sign in with your password and register your face again.",
    inactive: 'Your access has been revoked.',
    expired: 'The request expired, please try again.',
    unsupported: 'This device does not support face sign-in.',
    failed: 'Face sign-in failed. You can sign in with your password.',
  },
  enroll: {
    title: 'Register your face',
    body: 'Your device (Windows Hello, Face ID or fingerprint) will verify you once. After that you can sign in on this device without a password.',
    privacy: 'Your face data never leaves your device; HabcareCRO only receives a confirmation signed by your device.',
    start: 'Register my face',
    busy: 'Waiting for your device…',
    skip: 'Not now',
    success: 'Face sign-in is on for this device',
    exists: 'Face sign-in is already on for this device',
    cancelled: 'Face registration was not completed. You can try again or skip it for now.',
    freshLogin: 'For security, sign in with your password again first.',
    unsupported: 'This device does not support face sign-in.',
    failed: 'Face sign-in could not be set up. You can try again later.',
  },
  scan: {
    title: 'Face Scan',
    subtitle: 'Look at the camera; your sign-in photo is being taken.',
    camera: 'Camera',
    cameraStarting: 'Starting…',
    cameraOn: 'Active',
    cameraOff: 'Unavailable',
    photo: 'Sign-in photo',
    photoIn: '{{count}} s',
    photoTaken: 'Taken',
    processing: 'Processing',
    starting: 'Starting the camera...',
    skip: 'Sign In Now',
    continue: 'Continue',
    errors: {
      unsupported: 'The camera is not supported in this browser',
      denied: 'Camera access was denied',
      notFound: 'No camera found',
      failed: 'The camera could not be accessed',
      playback: 'The camera could not be opened',
    },
  },
  reset: {
    title: 'Forgot Password',
    body: "Enter your e-mail address and we'll send you a link to reset your password.",
    email: 'E-mail address',
    send: 'Send',
    sending: 'Sending...',
    cancel: 'Cancel',
    success: 'A password reset link has been sent to your e-mail address. Please check your inbox.',
    notFound: 'No user is registered with this e-mail address.',
    invalid: 'Invalid e-mail address.',
    failed: 'The password reset link could not be sent. Please try again.',
  },
  kvkk: {
    title: 'KVKK Privacy Notice and Explicit Consent',
    subtitle: 'Please read and accept to continue',
    protectionTitle: 'Protection of Personal Data',
    protection: 'Under Personal Data Protection Law No. 6698 ("KVKK"), your personal data may be processed by HCC HABCARE CRO within the scope described below.',
    controllerTitle: 'Data Controller',
    controller: 'Your personal data may be processed by HCC HABCARE CRO, as the data controller, within the scope described below.',
    dataTitle: 'Personal Data Processed',
    data: {
      identity: 'Identity details (first name, last name, Turkish ID number)',
      contact: 'Contact details (e-mail, phone, address)',
      employee: 'Employment details (department, position, authorisation)',
      logs: 'Sign-in records and system usage information',
      biometric: 'Biometric data (face recognition images)',
    },
    purposeTitle: 'Purposes of Processing',
    purpose: {
      contract: 'Concluding and performing the employment contract',
      hr: 'Employee management and human resources processes',
      security: 'System security and access control',
      legal: 'Fulfilling legal obligations',
      safety: 'Occupational health and safety practices',
    },
    transferTitle: 'Transfer of Personal Data',
    transfer: 'For the purposes above, your personal data may be transferred to third parties to the extent necessary to fulfil our legal obligations, perform the employment contract and pursue our legitimate interests.',
    rightsTitle: 'Your Rights',
    rightsIntro: 'Under Article 11 of the KVKK, by applying to our company you have the right to:',
    rights: {
      learn: 'learn whether your personal data is processed,',
      info: 'request information about it if it has been processed,',
      purpose: 'learn the purpose of processing and whether it is used accordingly,',
      thirdParties: 'know the third parties in Turkey or abroad to whom it is transferred,',
      correct: 'request correction if it is incomplete or inaccurate,',
      erase: 'request its deletion or destruction under the conditions set out in the legislation,',
      notify: 'request that third parties to whom it was transferred be notified of the above,',
      object: 'object to a result against you arising solely from analysis by automated systems,',
      damages: 'claim compensation if you suffer damage because of unlawful processing.',
    },
    consent: 'I have read and understood the KVKK Privacy Notice and give my explicit consent to the processing of my personal data within the scope described above.',
    accept: 'I Accept',
    reject: 'I Do Not Accept',
  },
};

export default login;
